import { useTranslation } from 'react-i18next';
import { Heading } from '../Heading';
import { WarningOutlined } from '../Icons';

export const WebinarNotPublishedWarning = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-white bg-side-warning bg-no-repeat rounded-lg flex flex-col items-start gap-1 mb-4 pl-6 md:pl-8 pr-4 md:pr-6 pt-4 pb-6 z-10">
            <WarningOutlined classNames="w-10 fill-warning mb-2" />
            <Heading variant="h3">{t('Webinar.Warning.NotPublished')}</Heading>
            <p className="max-w-3xl mb-4">{t('Webinar.Warning.NotPublished.Body')}</p>
        </div>
    );
};
